/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	
	window.enhancer = window.enhancer || {};
	var crop;
	
	enhancer.setImage = function (src) {
	  $('.container').croppie('destroy');
	  crop = $('.container').croppie({
	    viewport: {
	      width: 150,
	      height: 150,
	      type: 'square'
	    },
	    boundary: {
	      width: 300,
	      height: 300
	    }
	  });
	  crop.croppie('bind', {
	    url: src
	  });
	};
	
	$('.btn-choose').click(function (e) {
	  e.preventDefault();
	  $('.change-image').click();
	});
	$('.change-image').on('change', function (e) {
	  var files = e.target.files;
	  if (!crop) {
	    return;
	  }
	  [].forEach.call(files, function (item) {
	    if (item.type.match('image.*')) {
	      var src = URL.createObjectURL(item);
	      crop.croppie('bind', {
	        url: src
	      });
	    }
	  });
	});
	
	$('.btn-confirm').click(function (e) {
	  e.preventDefault();
	
	  if (crop) {
	    var en = window.parent.enhancer;
	    if (en && en.setAvatar) {
	      crop.croppie('result', 'canvas').then(function (resp) {
	        en.setAvatar(resp);
	      });
	    }
	  }
	});

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// crop.js